import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import image from "../../assets/Assets-V4/Switching/pro-max-24-poe@2x.jpg";
import v3Image from "../../assets/Switching/professionalMax24PoE.jpg";
import type { Product } from "../../types";
import { twoPointFiveTenGigabitEthernet } from "../product-groups/switching/2.5-10-gbe-1u";
import { professionalMax } from "../product-groups/twoPointFiveTenGigabitEthernet/professional-max";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const professionalMax24PoE: Product = {
  id: "professionalMax24PoE",
  productTitle: "Pro Max 24 PoE",
  description: "professionalMax24PoE.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-max-24-poe"],
  storePathParts: {
    productSlug: "usw-pro-max-24-poe",
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
  },
  sku: "USW-Pro-Max-24-PoE",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 294,
    height: 120,
  },
  productListGroup: productListSwitchingProfessional,
  productGroup: twoPointFiveTenGigabitEthernet,
  secondaryProductGroup: professionalMax,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 325 x 44 mm\n(17.4 x 12.8 x 1.7")',
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "24 + 2 SFP+" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo2_5Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "400 W" },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.unifiPowerBackupReady",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: true },
    },

    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
  ],
};
